import { useEffect } from "react";
import initAnalytics from "../initialization/index.js";
export default function useInitAnalytics() {
  useEffect(function () {
    initAnalytics();
  }, []);
}